import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { apolloClient } from '~/javascripts/lib/graphql';
import convertObjectPropsToCamelCase from '~/javascripts/lib/convert_object_props_to_camel_case';
import parseBoolean from '~/javascripts/lib/parse_boolean';
import tryJSONParse from '~/javascripts/lib/try_json_parse';
import AddonTransactionApp from './components/addon_transaction_app.vue';
import addonProducts from './products';

Vue.use(VueApollo);
const apolloProvider = new VueApollo({ defaultClient: apolloClient });

const datasetToProps = (dataset) => {
  if (!dataset) {
    return {};
  }

  return {
    productPrice: parseFloat(dataset.productPrice),
    backendErrorMessage: dataset.backendErrorMessage,
    currentNamespaceDetails: convertObjectPropsToCamelCase(
      tryJSONParse(dataset.currentNamespace, {}),
      { deep: true },
    ),
    successRedirectPath: dataset.successRedirectPath,
    planId: dataset.planId,
    ...addonProducts[dataset.addonType],
  };
};

const initTransactionApp = (container = '.js-addon-transaction') => {
  const el = document.querySelector(container);

  if (!el) {
    return false;
  }

  const props = datasetToProps(el.dataset);

  const { zuoraAccountNumber } = el.dataset;

  const customerBillingAccountsPresent = parseBoolean(el.dataset.customerBillingAccountsPresent);
  const user = convertObjectPropsToCamelCase(tryJSONParse(el.dataset.customer, {}));

  return new Vue({
    el,
    provide: {
      customerBillingAccountsPresent,
      zuoraAccountNumber,
      user,
    },
    render(createElement) {
      return createElement(AddonTransactionApp, {
        props,
      });
    },
    apolloProvider,
  });
};

export default initTransactionApp;
